export const insertItem = (data, item) => {
    item.inEdit = false;
    let index = data.findIndex((record) => record.Id === null);
    data[index] = item;
    return data;
  };
  
  export const updateItem = (data, item) => {
    item.inEdit = false;
    let index = data.findIndex((record) => record.Id === item.Id);
    data[index] = item;
    return data;
  };
  
  export const deleteItem = (data, item) => {
    let index = data.findIndex((record) => record.Id === item.Id);
    data.splice(index, 1);
    return data;
  };
  
  export const getFieldTypeId = (fieldType) => {
    switch (fieldType) {
      case "DynamicFormName":
        return "DynamicFormId";
      case "DynamicFieldColumnName":
        return "DynamicFieldColumnId";
      case "DynamicFieldName":
        return "DynamicFieldId";
      default:
        return fieldType;
    }
  };
  
  export const getListType = (fieldType) => {
    switch (fieldType) {
      case "DynamicFormName":
        return "DynamicForms";
      case "DynamicFieldColumnName":
        return "DynamicFieldColumns";
      case "DynamicFieldName":
        return "DynamicFields";
      case "IsVisible":
        return "Visible";
      case "IsDisabled":
        return "Disabled";
      default:
        return "";
    }
  };